import { jsxs as r, jsx as a } from "react/jsx-runtime";
const t = (l) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...l,
    children: [
      /* @__PURE__ */ a(
        "path",
        {
          fill: "currentColor",
          d: "M27.029 27.076a2.5 2.5 0 0 1-2.497-2.497 2.5 2.5 0 0 1 2.497-2.497 2.5 2.5 0 0 1 2.497 2.497 2.5 2.5 0 0 1-2.497 2.497ZM37.023 27.076a2.5 2.5 0 0 1-2.497-2.497 2.5 2.5 0 0 1 2.497-2.497 2.5 2.5 0 0 1 2.497 2.497 2.5 2.5 0 0 1-2.497 2.497ZM42.76 36.029a4 4 0 0 1-3.996-3.996 4 4 0 0 1 3.996-3.996 3.999 3.999 0 0 1 3.995 3.996 4 4 0 0 1-3.995 3.996ZM32.054 36.029a4 4 0 0 1-3.996-3.996 4 4 0 0 1 3.996-3.996 3.999 3.999 0 0 1 3.995 3.996 4 4 0 0 1-3.995 3.996ZM21.346 36.029a4 4 0 0 1-3.996-3.996 4 4 0 0 1 3.996-3.996 4 4 0 0 1 3.996 3.996 4 4 0 0 1-3.996 3.996ZM37.424 44.378a4 4 0 0 1-3.996-3.996 4 4 0 0 1 3.996-3.996 4 4 0 0 1 3.996 3.996 4 4 0 0 1-3.996 3.996ZM26.617 44.378a4 4 0 0 1-3.996-3.996 4 4 0 0 1 3.996-3.996 4 4 0 0 1 3.996 3.996 4 4 0 0 1-3.996 3.996Z"
        }
      ),
      /* @__PURE__ */ a(
        "path",
        {
          fill: "currentColor",
          d: "M54.455 32.196c.056-7.74-4.076-15.116-10.66-19.169h-23.59a22.495 22.495 0 0 0-4.126 3.262C7.953 24.416 7.42 37.92 14.824 46.658c2.981 3.517 7.013 6.168 11.486 7.338 10.993 2.875 22.885-3.332 26.747-14.002a23.461 23.461 0 0 0 1.398-7.798Zm-3.935.015c0 10.009-8.469 18.52-18.521 18.52-11.084 0-19.687-10.026-18.252-20.976.666-5.082 3.403-9.775 7.609-12.733h21.285a18.501 18.501 0 0 1 7.85 14.19l.006.136c.005.115.01.229.013.344.003.121.005.243.006.365l.002.126v.029h.001l.001-.001Z"
        }
      )
    ]
  }
);
export {
  t as ChargerType2
};
